import {Component, OnInit} from '@angular/core'
import {LayoutService} from '../../core/services/layout.service'
import {ApiService} from '../../core/services/api.service'
import {PageService} from '../../core/services/page.service'
import {ChatState} from '../../core/services/chat.service'
import {SitePage} from '../../site-page/site-page'
import { ActivatedRoute, Router } from '@angular/router'
import { PageNavigationService } from '../../core/services/page-navigation.service'
import { ModalStateService } from '../../core/services/modal-state.service'
import { NGXLogger } from 'ngx-logger'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-experience',
    templateUrl: './credit-tools.component.html',
    styleUrls: ['./credit-tools.component.scss', '../../site-page/site-page.scss'],
    standalone: false
})
export class CreditToolsComponent extends SitePage implements OnInit {
  hooverPopupTextMobile: string
  hooverPopupText: string
  public activeTemplate : any = '';
  equipmentProviderInActive: boolean = false;

  constructor(private layout: LayoutService,
              private api: ApiService,
              public page: PageService,
              public chatState: ChatState,
              public pageNavigationService: PageNavigationService,
              public modalStateService: ModalStateService,
              public logger: NGXLogger,
              route: ActivatedRoute,
              public sharedDataService: SharedDataService,
              public router: Router) {
      super(layout, api.getExperiencePage(), page, chatState, router, route, pageNavigationService, logger)
  }
  ngOnInit() {
    setTimeout(() => {
      if (this.api.modalPopupText) {
        this.hooverPopupText = this.api.modalPopupText
      }
      if (this.api.modalPopupTextMobile) {
        this.hooverPopupTextMobile = this.api.modalPopupTextMobile
      }
    }, 1000)
    this.checkAndRestore()
   // this.activeTemplate = this.sharedDataService.getRoute()
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()

  }


  checkAndRestore() {
    const prev = this.pageNavigationService.getPrevState()
    const current = this.pageNavigationService.getCurrentState()
    // our case or restoring
    if (current && current.trigger === 'popstate') {
      const type = this.modalStateService.getFromLocalStorage('modalType')
      const loanInfo = this.modalStateService.getFromLocalStorage('loanInfo')
      this.logger.info(type)
      this.logger.info(loanInfo)
      if (type) {
        this.toggleOptionsModal()
      }
      // switch(type) {
      //   case ModalTypes.mainform:
      //     this.logger.info(ModalTypes.mainform)

      //     break
      // }
    }
  }

}
